import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { customerFocusSalesHistorySelectItemGroup } from '../../../actions';

const ItemGroupFilter = ({placeholder}) => {
    const dispatch = useDispatch()
    const { authUser } = useSelector(({auth}) => auth);
    const { itemGroupSalesHistorySelected } = useSelector(({customerFocus}) => customerFocus)
    const [itemGroupData, setItemGroupData] = useState([]);
    const [selected, setSelected] = useState(itemGroupSalesHistorySelected);
    
    const handleChange = (selected) => {
        setSelected(selected)
        dispatch(customerFocusSalesHistorySelectItemGroup(selected))
    }

    useEffect(() => {
        let params = {
          company: authUser.company !== "#" ? authUser.company : "",
          salesmanCode: authUser.salesman !== "#" ? authUser.salesman : "",
          username: authUser.username,
          language: 1
        }
    
        const url = `${process.env.REACT_APP_API_URL}customer/findItemGroupMaster?company=${params.company}&language=${params.language}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}}).then(res => {
            const resultData = res.data;
            if (Array.isArray(resultData)) {
                resultData.sort((a, b) => {
                    const valA = String(a.value || "").toLowerCase();
                    const valB = String(b.value || "").toLowerCase();
                    const labelA = String(a.label || "").toLowerCase();
                    const labelB = String(b.label || "").toLowerCase();
                    
                    if (valA === "unassigned" || labelA === "unassigned") return -1;
                    if (valB === "unassigned" || labelB === "unassigned") return 1;
                    return 0;
                });
            }
            setItemGroupData(resultData)
        })
      },[authUser, itemGroupSalesHistorySelected])

    // const customStyles = {
    //     control: (base, state) => ({
    //       ...base,
    //       width: '150px',
    //       'min-width': '150px'
    //     }),
    // };

    const customStyles = {
        menu: (provided, state) => ({
            ...provided,
            zIndex: 9999
        }),
    }

    return(
        <Select
            styles={customStyles}
            value={selected}
            onChange={handleChange}
            options={itemGroupData}
            placeholder={placeholder}
            isMulti={true}
            isClearable={true}
            />
    );
}

export default ItemGroupFilter;